module.exports = "<nav class=\"nav\">\n        <a class=\"nav-link\" routerLink=\"\">Strona Głowna</a>\n        <a class=\"nav-link\" href=\"#\">Mapa Kielc</a>\n        <a class=\"nav-link\" routerLink=\"/stops\">Przystanki autobusowe</a>\n        <a class=\"nav-link\" routerLink=\"/lines\">Linie autobusowe</a>\n        <a class=\"nav-link\" routerLink=\"/about\">O autorze</a>\n    </nav>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main